import { type FunctionalComponent, h } from '@stencil/core';
import { Suggestion } from './suggestion';
import type { GuidedApiSuggestion } from '../api';

export interface SuggestionProps {
  suggestions: Array<GuidedApiSuggestion>;
  labelProvider: CallableFunction;
  clickHandler: CallableFunction;
}
export const Suggestions: FunctionalComponent<SuggestionProps> = (props) => {
    const { suggestions, labelProvider, clickHandler } = props;

    //NOTE: suggestions are not filtered by group name!
    const suggestionLabel = labelProvider('search-for-suggestions', 'Search for');
    return (
      <div class="guided-pane__suggestions">
        {suggestionLabel ? (
          <div class="guided-pane__suggestions-label">{suggestionLabel}</div>
        ) : (
          ''
        )}
        <ul class="guided-pane__suggestions-list">
          {suggestions.map((suggestion) => (
            <li>
              <Suggestion
                suggestion={suggestion}
                clickHandler={clickHandler}
              ></Suggestion>
            </li>
          ))}
        </ul>
      </div>
    );
};
